import { render, staticRenderFns } from "./ChartResignation.vue?vue&type=template&id=181d4e47&scoped=true"
import script from "./ChartResignation.vue?vue&type=script&lang=js"
export * from "./ChartResignation.vue?vue&type=script&lang=js"
import style0 from "./ChartResignation.vue?vue&type=style&index=0&id=181d4e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d4e47",
  null
  
)

export default component.exports